import { jsx as i } from "react/jsx-runtime";
import { useContext as e } from "react";
import { ThemeContext as c } from "../ThemeContext/index.js";
import s from "../../icons/LoadingCircle.js";
const m = "forma-ui__loading-indicator__icon", a = {
  icon: m
}, l = ({ color: t = "inherit", size: n }) => {
  const { viewport: r } = e(c), o = n ?? (r === "phone" ? "32px" : "46px");
  return /* @__PURE__ */ i("div", { className: a.icon, children: /* @__PURE__ */ i(s, { width: o, height: o, color: t }) });
};
export {
  l as default
};
